import { lineFamilyOf } from './line-family.js';
/**
 * True when every family-bearing line on the order is Sample type, and at least one such line
 * exists. An order with zero lines (or only charge-type lines) is never a sample order — `every`
 * on an empty set is vacuously true, so the "at least one" check guards against that.
 */
export function isSampleOrder(items) {
    const familyBearing = items.filter((item) => lineFamilyOf(item.typeId) !== null);
    if (familyBearing.length === 0)
        return false;
    return familyBearing.every((item) => lineFamilyOf(item.typeId) === 'sample');
}
//# sourceMappingURL=is-sample-order.js.map